import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./AreaUIHelpers";

const AreaUIContext = createContext();

export function useAreaUIContext() {
  return useContext(AreaUIContext);
}

export const AreaUIConsumer = AreaUIContext.Consumer;

export function AreaUIProvider({ areaUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initArea = {
    name: "",
    thk_period_uuid: "",
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initArea,
    newAreaButtonClick: areaUIEvents.newAreaButtonClick,
    openEditAreaPage: areaUIEvents.openEditAreaPage,
  };

  return (
    <AreaUIContext.Provider value={value}>{children}</AreaUIContext.Provider>
  );
}
